import styled from "@emotion/styled";
import React from "react";

import { CoreLink } from "@brexhq/next/src/components/shared/Link/CoreLink";
import { InlineLinkProps } from "@brexhq/next/src/components/shared/Link/types";

const StyledNavLink = styled(CoreLink)(({ theme }) => {
  return {
    fontFamily: theme.rebirth.fonts.family,
    color: theme.colors.content.primary,
    fontVariationSettings: '"wght" 600',
    fontSize: "14px",
    lineHeight: "22px",
    textDecoration: "none",
    "&:hover": {
      color: theme.colors.content.primary,
      textDecoration: "none",
    },
  };
});

export const NavLink = React.forwardRef<HTMLAnchorElement, InlineLinkProps>(
  function NavLinkComponent(
    { to, label, target, rel, prefetch, ...defaultProps },
    ref,
  ) {
    return (
      <StyledNavLink
        ref={ref}
        to={to}
        target={target}
        rel={rel}
        prefetch={prefetch}
        {...defaultProps}
      >
        {label}
      </StyledNavLink>
    );
  },
);
